module.exports = __webpack_public_path__ + "img/shipo-banner-contract-bg.1046d3d7.svg";